import { Layer } from "shared/types/salesEnablement";
import { OnLayerChangeFunc } from "../Layers";
import LayerTypeToggle from "./layerName/LayerTypeToggle";
import styles from "./LayerName.module.scss";
import { isOtherGrouplayer } from "../utils";

type Props = {
  groupable?: boolean; // indicating if the layer can be grouped/un-grouped. "undefined" means it is groupable by default.
  layer: Layer;
  isChildLayer?: boolean;
  onChange?: OnLayerChangeFunc;
  disabled?: boolean;
};
const LayerName = (props: Props) => {
  const { layer, onChange, isChildLayer, groupable = true, disabled } = props;
  const { name } = layer;

  return (
    <div className={styles.container}>
      <LayerTypeToggle
        disabled={disabled || !groupable}
        layer={layer}
        isChildLayer={isChildLayer ?? false}
        onChange={onChange}
      />

      <span
        className={
          isOtherGrouplayer(layer) && layer.subLayers.length > 0
            ? styles.groupLayerTitle
            : ""
        }
      >
        {name}
      </span>
    </div>
  );
};

export default LayerName;
